import { render, staticRenderFns } from "./AiRequirementItem.vue?vue&type=template&id=fc0cca9c&scoped=true"
import script from "./AiRequirementItem.vue?vue&type=script&lang=js"
export * from "./AiRequirementItem.vue?vue&type=script&lang=js"
import style0 from "./AiRequirementItem.vue?vue&type=style&index=0&id=fc0cca9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc0cca9c",
  null
  
)

export default component.exports